<template>
  <div class="yx-bdd-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 报到单统计 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <!-- <el-button type="primary" @click="goto('')">新增</el-button> -->
          <el-button type="primary" plain>导出</el-button>
          <el-button type="primary" plain>批量导出报到单</el-button>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          @edit="goto"
          @delete="pageDel"
          v-loading="pageLoading"
        >
        </c-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/bdd";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import { getOrgOptions } from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    studentName: "",
    collegeId: "",
    departmentId: "",
    majorId: "",
    classId: "",
  },
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      pageData: [
        {
          id: 1,
        },
      ],
    };
  },
  created() {
    getOrgOptions(this, { type: "college" }, 1, null);
  },
  mounted() {},
  methods: {
    goto(id) {
      if (id) {
        // this.$router.push("/lx/baseData/studentEdit/" + id);
      } else {
        // this.$router.push("/lx/baseData/studentAdd");
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.searchItems[4].options = [];
      this.pageParams = {
        studentName: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    pageGetAfterFn(data) {
      data.records.forEach((item) => {
        item.sex = item.sex == 0 ? "男" : "女";
      });
      return data;
    },
    handleGetReviewer() {},
  },
};
</script>
